import React from 'react'
import { faqData } from '../../faq'
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel
} from "react-accessible-accordion";
import './faq.m.css'
import { Link } from '@quintype/components';

export const Faq = () => {
    const [isCollapsed, setIsCollapsed] = React.useState(true)
    const subFaqData = faqData.filter(data=>data.sectionName==="Subscription basics")
  
    return(
        <div styleName="section-wrapper" className='full-width'>
               <h2>Frequently asked questions</h2>
            <div styleName='faq-wrapper'>
                {subFaqData.map(sec => (
                    <div key={sec.sectionName} id={`${sec.id}`}>
                     
                        <Accordion allowZeroExpanded>
                            {sec.children.slice(0,5).map(item => (
                            <AccordionItem key={item.q}>
                                <AccordionItemHeading>
                                <AccordionItemButton>{item.q}</AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>{item.a}</AccordionItemPanel>
                            </AccordionItem>
                            ))}
                        </Accordion>
                        <Link href="/faq"><button >View more</button></Link>
                    </div>
                ))}
            </div>
        </div>
    )
}